var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import cloneDeep, { isEqual } from "lodash-es";
const AnyInput = {
  // eslint-disable-next-line function-paren-newline
  component: async () => (await import(/* webpackChunkName: "anyinput" */
  '../../../../../builtin/designerComponents/AnyInput')).default
};
let DevToolEditor = class DevToolEditor extends Vue {
  constructor() {
    super(...arguments);
    this.localData = {};
    this.editing = false;
  }
  mounted() {
    this.localData = cloneDeep(this.value).value();
    this.$watch('value', newVal => {
      if (!this.editing) this.localData = cloneDeep(newVal).value();
    }, {
      deep: true,
      immediate: true
    });
    this.$watch('localData', (newVal, oldVal) => {
      if (isEqual(newVal, oldVal)) return;
      this.$emit('change', newVal);
    });
  }
  get cmOptions() {
    const cmOptions = {
      readOnly: !this.isDesignMode
    };
    if (this.isDarkMode) {
      cmOptions.theme = 'zenburn'; // 需要同时引入样式
    }
    return cmOptions;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-jsonview-editor"
    }, [h(AnyInput, {
      "attrs": {
        "value": this.localData,
        "inputSync": true,
        "castMode": this.editOption,
        "hideIcon": true,
        "propCmOptions": this.cmOptions
      },
      "on": {
        "change": val => {
          this.editing = true;
          this.localData = val;
        },
        "blur": () => this.editing = false
      },
      "class": 'ucd-devTool-codeMirror'
    }), h("a-checkbox", {
      "style": {
        marginBottom: '10px'
      },
      "attrs": {
        "checked": this.showDefaultProps
      },
      "on": {
        "change": e => this.$emit('update', e.target.checked)
      }
    }, [" \u663E\u793A\u9ED8\u8BA4\u503C "])]);
  }
};
DevToolEditor = __decorate([Component({
  name: 'DevToolEditor',
  props: {
    value: {
      type: [String, Boolean, Number, Object, Array]
    },
    editOption: {
      type: String,
      default: 'json'
    },
    showDefaultProps: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: 'none'
    },
    isDesignMode: {
      type: Boolean,
      default: true
    },
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  model: {
    event: 'change',
    prop: 'value'
  }
})], DevToolEditor);
export default DevToolEditor;